<template>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="date">Nama Gudang </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="date">Unit </label>
                <input type="text" v-model="model.unit_id" class="form-control" readonly>
            </div>
        </div>

        <div class="col-md-12">
            <div class="form-group">
                <label for="date">Deskripsi </label>
                <input type="text" v-model="model.description" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'FormRiwayat',
    components: {},
    data() {
        return {
            saving: false,
            linkBukti: '',
            model: {
                name: '',
                unit_id: '',
                description: ''
            },
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', description: '', unit_id: null}
        },
        editMode(item) {
            this.model.id = item.id
            this.model.name = item.name
            this.model.description = item.description
            this.model.unit_id = item.unit?.name
        },
    },
    watch: {
    }
}
</script>